<script>
import AdsPaymentMethod from './components/ads-payment-method.vue'
import TopUpSuccess from './components/top-up-success.vue'

export default {
  name: 'AdsTopUpResponse',
  components: { TopUpSuccess, AdsPaymentMethod },
  computed: {
    responseType() {
      return this.$route.meta.responseType
    },
  },
  created() {
    // Remove any params that we got when redirect back from Checkout site
    const url = new URL(window.location)
    if (url.searchParams.size > 0) {
      url.search = ''
      window.history.replaceState({}, document.title, url.toString())
    }
  },
}
</script>

<template>
  <div class="ads-top-up-response">
    <main>
      <TopUpSuccess v-if="responseType === 'success'" />

      <template v-if="responseType === 'error'">
        <div class="icon-container error-icon">
          <svg-icon icon-class="warning-circle-colorless" />
        </div>
        <h1>{{ $t('ads_top_up_failed_title') }}</h1>
        <p>
          {{ $t('ads_top_up_failed_desc') }}
        </p>
        <div class="inline-cta-container">
          <router-link to="/ads/dashboard" class="secondary-cta-btn" replace>
            {{ $t('ads_top_up_failed_later') }}
          </router-link>
          <router-link
            to="/ads/ads-credit/top-up"
            class="primary-cta-btn"
            replace
          >
            {{ $t('ads_top_up_failed_try_again') }}
          </router-link>
        </div>
      </template>

      <template v-if="responseType === 'pending'">
        <div class="icon-container pending-icon">
          <svg-icon icon-class="clock-yellow" />
        </div>
        <h1>
          {{ $t('ads_top_up_pending_title') }}
        </h1>
        <p>
          {{ $t('ads_top_up_pending_desc') }}
        </p>
        <router-link to="/ads/ads-credit" class="primary-cta-btn mb-3" replace>
          {{ $t('ads_top_up_pending_to_balance') }}
        </router-link>
        <router-link to="/ads/dashboard" class="secondary-cta-btn" replace>
          {{ $t('ads_top_up_success_to_dashboard') }}
        </router-link>
      </template>
      <template v-if="responseType === 'pay-now'">
        <AdsPaymentMethod />
      </template>
    </main>
  </div>
</template>

<style lang="scss" scoped>
@mixin direction-aware-font {
  [dir='ltr'] & {
    font-family: 'Space Grotesk', sans-serif;
  }
  [dir='rtl'] & {
    font-family: 'IBM Plex Sans Arabic', sans-serif;
  }
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 522px;
  padding: 48px;
  text-align: center;
  background: #fff;
  border-radius: 20px;
}

.ads-top-up-response {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  // Due to body hav zoom: 90%
  // => we have to set min-height to 111.11vh to cover entire screen height
  min-height: 111.11vh;
  background: #0009;
}

.ads-top-up-response ::v-deep {
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    margin-block-end: 20px;
    border-radius: 100%;

    svg {
      width: 40px;
      height: 40px;
    }
  }

  h1 {
    @include direction-aware-font;

    margin-block-end: 8px;
    font-size: 24px;
    font-weight: 600;
    line-height: 31px;
  }

  p {
    margin-block-end: 20px;
    font-size: 14px;
    line-height: 22px;
    color: #666;
  }

  .primary-cta-btn {
    width: 100%;
    padding: 16px;
    font-size: 16px;
    line-height: 20px;
    color: #fff;
    background: black;
    border: 1px solid rgb(0, 0, 0);
    border-radius: 10px;
  }

  .secondary-cta-btn {
    width: 100%;
    padding: 16px;
    font-size: 16px;
    line-height: 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
}

.error-icon {
  background: #e835501a;

  svg {
    color: #e83550;
  }
}

.pending-icon {
  background: #efa91c33;
}

.inline-cta-container {
  display: flex;
  gap: 12px;
  width: 100%;
}
</style>
